<template>
  <div v-if="visible" id="tab-hbl">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div class="operat-wrap">
          <el-dropdown
            no="command1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyMbl')">{{ $t('SeaExport.CopyMbl') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="originalPrint"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}
          </el-button>
          <el-button v-show="form.state===2" :disabled="!(form.state===2 && this.$checkPermission(['button_M/HBL_unlock']))" no="Unlock" type="primary" @click="unlock">{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button
            no="showAddressFormatDialog"
            :disabled="readonly||!form.uuid"
            type="primary"
            @click="showAddressFormatDialog"
          >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
          <el-dropdown
            v-if="!OpenXHQDocumentCenter"
            no="command2"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{ $t('SeaExport.InviteToChecktheBL') }}</el-dropdown-item>
              <el-dropdown-item v-permission="['button_M/HBL_confirmBL']" :command="$t('SeaExport.ConfirmChecking')">{{ $t('SeaExport.ConfirmChecking') }}</el-dropdown-item>
              <el-dropdown-item v-permission="['button_M/HBL_identification']" :command="$t('SeaExport.IdentificationList')">{{ $t('SeaExport.IdentificationList') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{ $t('SeaExport.CheckingHistory') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.UploadGuarantee')">{{ $t('SeaExport.UploadGuarantee') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-menu
            v-if="OpenXHQDocumentCenter && (job.typeHBL === 0 || job.typeHBL === 1)"
            :class="isEdit?'is-disabled not-click':''"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="vertical-align: top"
            @select="XHQDocumentCenterSelectHandler"
          >
            <el-submenu index="index">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.InviteToChecktheBL') }}</span>
              <el-menu-item index="InviteToChecktheBL">{{ $t('SeaExport.InviteToChecktheBL') }}</el-menu-item>
              <el-submenu :index="$t('SeaExport.UploadCustomerFiles')">
                <template slot="title">{{ $t('SeaExport.UploadCustomerFiles') }}</template>
                <el-menu-item index="BillOfLadingConfirmationDocument">{{ $t('Clearing.BillOfLadingConfirmationDocument') }}</el-menu-item>
                <el-menu-item index="CustomerSelfIssuedFiles">{{ $t('SeaExport.CustomerSelfIssuedFiles') }}</el-menu-item>
                <el-menu-item v-if="ToExoSystemJYD" index="OriginBillOfLading">{{ $t('SeaExport.OriginBillOfLading') }}</el-menu-item>
                <el-menu-item index="ShippingOrder">{{ $t('SeaExport.ShippingOrder') }}</el-menu-item>
              </el-submenu>
              <el-menu-item index="CheckTheBLLog">{{ $t('SeaExport.CheckTheBLLog') }}</el-menu-item>
              <el-menu-item index="ConfirmChecking">{{ $t('SeaExport.ConfirmChecking') }}</el-menu-item>
              <el-menu-item index="UploadGuarantee">{{ $t('SeaExport.UploadGuarantee') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-button v-if="OpenXHQDocumentCenter && this.$checkPermission(['button_M/HBL_identification'])" :disabled="isEdit" no="IdentificationList" type="primary" @click="onIdentificationList">{{ $t('SeaExport.IdentificationList') }}</el-button>
          <!-- 对单链接-->
          <el-button v-if="ToExoSystemJYD && (job.typeHBL === 0 || job.typeHBL === 1)" :disabled="isEdit" no="CustomerToOrder" type="primary" @click="onOpenDocLink(0)">{{ $t('SeaExport.CustomerToOrder') }}</el-button>
          <el-button v-if="ToExoSystemJYD && (job.typeHBL === 0 || job.typeHBL === 1)" :disabled="isEdit" no="DesignatedGoodsToBillOfLading" type="primary" @click="onOpenDocLink(1)">{{ $t('SeaExport.DesignatedGoodsToBillOfLading') }}</el-button>
          <el-button
            v-if="OpenXHQDocumentCenter && (job.typeHBL === 0 || job.typeHBL === 1)"
            :disabled="isEdit"
            no="updateBillInfo"
            type="primary"
            @click="pm.updateBillInfo()"
          >{{ $t('SeaExport.ConfirmationBillOfLading') }}</el-button>
          <el-button
            v-if="viewSource === 'SeBooking'"
            v-permission="['button_insurance_toInsure']"
            no="Insure"
            :disabled="isEdit"
            type="primary"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}</el-button>
          <el-menu
            v-permission="['button_EDI_overseasAgentForecast']"
            :disabled="!(action === 'look' && form.uuid)"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="width: 100px;vertical-align: top"
            @select="toOverseaAgeFore"
          >
            <el-submenu index="index" :disabled="!(action === 'look' && form.uuid)">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.OverseasAgeFore') }}</span>
              <el-menu-item :index="$t('SeaExport.Original')">{{ $t('SeaExport.Original') }}</el-menu-item>
              <el-menu-item :index="$t('SeaExport.Correct')">{{ $t('SeaExport.Correct') }}</el-menu-item>
              <el-menu-item :index="$t('CargoMsg.Cargo_Delete')">{{ $t('CargoMsg.Cargo_Delete') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <!-- 指令操作按钮 -->
          <template v-for="(item, index) in instructioinBtns">
            <el-button
              v-if="item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_PRINT_FILE.code"
              :key="index"
              :no="item.platformInstructionRuleCode"
              type="primary"
              :disabled="!readonly || !item.allowOperate"
              @click="onInstructionClick(item)"
            >
              {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
            </el-button>
          </template>
          <el-checkbox
            :value="form.state===2"
            :disabled="true"
          >{{ $t('SeaExport.Locked') }}</el-checkbox>
          <el-checkbox v-model="form.oversea" no="oversea" :disabled="readonly">{{ $t('SeaExport.BlBeReleasedElsewhereOrNot') }}</el-checkbox>
          <el-checkbox v-model="form.manifestEDI" no="manifestEDI" :disabled="readonly">{{ $t('SeaExport.ManifestEdi') }}</el-checkbox>
          <el-checkbox v-model="form.printParam1" no="printParam1" :disabled="readonly">Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="printParam2" :disabled="readonly">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <!-- CARGO-30498 海运出口 HBL箱封信息栏位刷新逻辑调整 -->
          <!-- <el-checkbox
            v-model="form.printParam3"
            no="printParam3"
            :disabled="readonly"
            @change="val=>{pm.chargeContainer(val)}"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox> -->
          <el-checkbox
            v-model="form.printParam3"
            no="printParam3"
            :disabled="readonly"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
          <el-checkbox v-model="chkConsolidationClosed" no="chkConsolidationClosed" :disabled="readonly">{{ $t('SeaExport.AFRTheLastBill') }}</el-checkbox>
          <el-checkbox v-show="job.barge" v-model="form.printParam6" no="printParam6" :disabled="readonly">{{ $t('SeaExport.PrintBargeVesselAndVoyage') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease"
            :value="form.customerSelfRelease===1"
            :disabled="readonly"
            @input="isCustomerSelfRelease"
          >{{ $t('SeaExport.CustomerSelfRelease') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease2"
            :value="form.customerSelfRelease===2"
            :disabled="readonly"
            @input="isCompanySelfRelease"
          >{{ $t('SeaExport.CompanySelfRelease') }}</el-checkbox>
        </div>
      </div>
    </div>
    <tab-HBL-UICustom-layout :element-blocks="elementBlocks">
      <template v-if="elementDict.shipper.viewable" slot="shipper">
        <el-form-item class="auto-width">
          <template slot="label">
            <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
            <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex">
            <el-input
              v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
              ref="shipperCode"
              v-model="form.shipperCode"
              :disabled="readonly || !elementDict.shipper.writable"
              no="shipperCode"
              style="flex:1"
              :class="importDifferenceField.shipperCode ? 'red-border' : ''"
            />
            <cargo-advance-select
              v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
              :disabled="readonly || !elementDict.shipper.writable"
              no="shipperId"
              :select-type="selectTypeNames.basic_data_Company"
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              :method-params="{ shipper: true, active: true }"
              filterable
              :default-value="form.shipperId||''"
              tag-name="englishName"
              style="flex:1;"
              :class="importDifferenceField.shipperId ? 'red-border' : ''"
              @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
            />
            <el-button :disabled="readonly || !elementDict.shipper.writable" type="primary" style="margin-left: 6px;" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item v-for="count in 7" :key="'shipperLine'+count" :class="'auto-width '+ getClass('shipperLine',count)">
          <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
            <cargo-input
              :ref="'shipperLine'+count"
              v-model="form['shipperLine'+count]"
              :disabled="readonly || !elementDict.shipper.writable"
              :no="'shipperLine'+count"
              :placeholder="placeholderSFT(count)"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :filter-chars="false"
              :use-read-only="true"
              :class="importDifferenceField['shipperLine'+count] ? 'red-border' : ''"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
            />
          </special-character-tip>
        </el-form-item>
      </template>
      <template v-if="elementDict.consignee.viewable" slot="consignee">
        <el-form-item class="auto-width">
          <template slot="label">
            <line-label :class="(elementDict.consignee.isRequire ? 'blue ' : '') + variableCss.consigneeLine" :label="elementDict.consignee.label" />
            <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex">
            <el-input
              v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
              ref="consigneeCode"
              v-model="form.consigneeCode"
              :disabled="readonly || !elementDict.consignee.writable"
              no="consigneeCode"
              style="flex:1"
              :class="importDifferenceField.consigneeCode ? 'red-border' : ''"
            />
            <cargo-advance-select
              v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
              :disabled="readonly || !elementDict.consignee.writable"
              no="consigneeId"
              :select-type="selectTypeNames.basic_data_Company"
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              :method-params="{ consignee: true, active: true }"
              filterable
              :default-value="form.consigneeId||''"
              tag-name="englishName"
              style="flex:1;"
              :class="importDifferenceField.consigneeId ? 'red-border' : ''"
              @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
            />
            <el-button type="primary" :disabled="readonly || !elementDict.consignee.writable" style="margin-left: 6px;" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item
          v-for="count in 7"
          :key="'consigneeLine'+count"
          v-model="form['consigneeLine'+count]"
          :class="'auto-width ' + getClass('consigneeLine',count)"
        >
          <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
            <cargo-input
              :ref="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :disabled="readonly || !elementDict.consignee.writable"
              :no="'consigneeLine'+count"
              :placeholder="placeholderSFT(count)"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :filter-chars="false"
              :class="importDifferenceField['consigneeLine'+count] ? 'red-border' : ''"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
            />
          </special-character-tip>
        </el-form-item>
      </template>
      <template v-if="elementDict.notify.viewable" slot="notify">
        <el-form-item class="auto-width">
          <template slot="label">
            <line-label :class="(elementDict.notify.isRequire ? 'blue ' : '') + variableCss.notifyLine" :label="elementDict.notify.label" />
            <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div>
            <el-input
              v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
              ref="notifyCode"
              v-model="form.notifyCode"
              :disabled="readonly || !elementDict.notify.writable"
              :class="importDifferenceField.notifyCode ? 'red-border' : ''"
              no="notifyCode"
            />
            <cargo-advance-select
              v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
              :disabled="readonly || !elementDict.notify.writable"
              no="notifyId"
              :select-type="selectTypeNames.basic_data_Company"
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              :method-params="{ notify: true, active: true }"
              filterable
              :default-value="form.notifyId||''"
              tag-name="englishName"
              :class="importDifferenceField.notifyId ? 'red-border' : ''"
              @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
            />
            <div style="margin-top: 5px">
              <el-button no="Reset" type="primary" :disabled="readonly || !elementDict.notify.writable" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-button no="CopyTheConsignee" type="primary" :disabled="readonly || !elementDict.notify.writable" style="margin-left: 5px;" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-for="count in 7"
          :key="'notifyLine'+count"
          :class="'auto-width ' + getClass('notifyLine',count)"
        >
          <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
            <cargo-input
              :ref="'notifyLine'+count"
              v-model="form['notifyLine'+count]"
              :disabled="readonly || !elementDict.notify.writable"
              :no="'notifyLine'+count"
              :placeholder="placeholderSFT(count)"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :filter-chars="false"
              :class="importDifferenceField['notifyLine'+count] ? 'red-border' : ''"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
            />
          </special-character-tip>
        </el-form-item>
      </template>
      <template v-if="elementDict.agentParty.viewable" slot="agentParty">
        <el-form-item class="auto-width">
          <line-label slot="label" :class="(elementDict.agentParty.isRequire ? 'blue ' : '') + variableCss.agentPartyLine" :label="elementDict.agentParty.label" :style="elementDict.agentParty.isRequire || variableCss.agentPartyLine ?'': 'color:#404144!important;' " />
          <div style="text-align: right">
            <el-button no="onClear4" type="primary" :disabled="readonly || !elementDict.agentParty.writable" style="min-width:50px;margin-right: 5px" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
            <el-dropdown
              no="command3"
              :class="readonly?'not-click':''"
              split-button
              type="primary"
              :disabled="readonly || !elementDict.agentParty.writable"
              @click="commandHandle(command3)"
              @command="p=>{command3=p;commandHandle(command3)}"
            >
              {{ command3 }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-form-item>
        <el-form-item
          v-for="count in 7"
          :key="'agentPartyLine'+count"
          :class="'auto-width ' + getClass('agentPartyLine',count)"
        >
          <cargo-input
            :ref="'agentPartyLine'+count"
            v-model="form['agentPartyLine'+count]"
            :disabled="readonly || !elementDict.agentParty.writable"
            :no="'agentPartyLine'+count"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            :use-read-only="true"
            :filter-chars="false"
            @dblclick.native="showAgentPartyDialog"
            @change="()=>wrapAddr(form,'agentPartyLine'+count,count+1 > 6 ? null :'agentPartyLine'+(count+1),maxChars)"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.alsoNotify.viewable" slot="alsoNotify">
        <el-form-item class="auto-width">
          <line-label slot="label" :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" :label="elementDict.alsoNotify.label" style="color:#404144" />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-rich-textarea
            v-model="form.alsoNotify"
            :disabled="readonly || !elementDict.alsoNotify.writable"
            no="alsoNotify"
            :text-chars="0"
            wrap-symbol="r"
            auto-half-word
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify,{warningCount:45,autoUppercase:notUppercaseShipperConsigneNotify,autoHalfWord:true})"
          />
        </el-form-item>
      </template>
      <el-form-item
        v-if="elementDict.quantity.viewable"
        slot="quantity"
        :class="variableCss.quantity"
      >
        <line-label slot="label" :class="elementDict.quantity.isRequire ? 'blue' : ''" :label="elementDict.quantity.label" />
        <auto-number-input
          v-model="form.quantity"
          no="quantity"
          :precision="0"
          :min="0"
          :disabled="!isJydEditJobFields || readonly || !elementDict.quantity.writable"
          :class="importDifferenceField.quantity ? 'red-border' : ''"
          @change="pm.quantity_Change()"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.viewable" slot="packing" :class="variableCss.packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="packing"
          :disabled="readonly || !elementDict.packing.writable"
          :default-value="form.packing"
          :class="importDifferenceField.packing ? 'red-border' : ''"
          @change="p => {pm.packing_Change(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packingName.viewable" slot="packingName">
        <line-label slot="label" :class="elementDict.packingName.isRequire ? 'blue' : ''" :label="elementDict.packingName.label" />
        <el-input v-model="form.packingName" :class="importDifferenceField.packingName ? 'red-border' : ''" no="packingName" :disabled="readonly || !elementDict.packingName.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity" :class="variableCss.insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="job.insideQuantity"
          no="insideQuantity"
          :precision="0"
          :min="0"
          :class="importDifferenceField.insideQuantity ? 'red-border' : ''"
          :disabled="readonly || !elementDict.insideQuantity.writable"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insidePacking.viewable" slot="insidePacking" :class="variableCss.insidePacking">
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          :default-value="form.insidePacking"
          no="insidePacking"
          :class="importDifferenceField.insidePacking ? 'red-border' : ''"
          :disabled="readonly || !elementDict.insidePacking.writable"
          @change="p => {form.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.weight.viewable" slot="weight" :class="variableCss.weight">
        <line-label slot="label" :class="elementDict.weight.isRequire ? 'blue' : ''" :label="elementDict.weight.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.weight ? 'red-border' : ''">
          <el-input-number
            v-model="form.weight"
            no="weight"
            :disabled="!pm.isCanEditQwc || !isJydEditJobFields || readonly || !elementDict.weight.writable"
            :precision="3"
            :min="0"
            :controls="false"
            style="flex:1"
            @change="p=>{pm.changeBillOfLadingSynJob();pm.calculateChargeWeight();}"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubage.viewable" slot="cubage" :class="variableCss.cubage">
        <line-label slot="label" :class="elementDict.cubage.isRequire ? 'blue' : ''" :label="elementDict.cubage.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.cubage ? 'red-border' : ''">
          <el-input-number
            v-model="form.cubage"
            no="cubage"
            :disabled="!pm.isCanEditQwc || !isJydEditJobFields || readonly || !elementDict.cubage.writable"
            :precision="3"
            :min="0"
            :controls="false"
            style="flex: 1"
            @change="p=>{pm.changeBillOfLadingSynJob();pm.calculateChargeWeight();}"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.viewable" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.chargeWeight ? 'red-border' : ''">
          <el-input-number
            v-model="form.chargeWeight"
            no="chargeWeight"
            :precision="3"
            :min="0"
            style="flex: 1"
            :controls="false"
            :disabled="readonly || !elementDict.chargeWeight.writable"
            @change="pm.changeBillOfLadingSynJob()"
          />
          <span>M/T</span>
        </div>
      </el-form-item>
      <template slot="cargoEnglishName">
        <el-form-item
          v-show="elementDict.cargoEnglishName.viewable"
          label-width="0"
          class="auto-width"
          :class="variableCss.cargoEnglishName"
        >
          <el-button
            v-show="isEdit"
            no="getMBLInfoEName"
            type="primary"
            style="float:right"
            :disabled="readonly || !elementDict.cargoEnglishName.writable"
            @click="pm.getMBLInfo('EName')"
          >
            {{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMbl') }}
          </el-button>
        </el-form-item>
        <el-form-item v-show="elementDict.cargoEnglishName.viewable" :label="$t('SeaExport.EnglishDescriptionOfGoods')" :class="'auto-width '+variableCss.cargoEnglishName">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <special-character-tip :texts="specialCharCheck.cargoEnglishName">
            <cargo-rich-textarea
              ref="cargoTextarea1"
              v-model="form.cargoEnglishName"
              no="cargoEnglishName"
              :show-count="true"
              :text-chars="englishNameMaxChars"
              :warning-count="englishNameWarningCount"
              wrap-symbol="r"
              :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
              :auto-uppercase="isUppercaseByConfig"
              auto-half-word
              style="height: 110px"
              :class="importDifferenceField.cargoEnglishName ? 'red-border' : ''"
              @change="p=>{syncAms('cargoEnglishName');pm.cargoEnglishNameBlurHandler()}"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val;syncAms('cargoEnglishName')},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig,warningCount: englishNameWarningCount,maxChar: englishNameMaxChars})"
            />
          </special-character-tip>
        </el-form-item>
      </template>
      <template slot="mark">
        <el-form-item
          v-show="elementDict.mark.viewable"
          label-width="0"
          class="auto-width"
          :class="variableCss.mark"
        >
          <el-button
            v-show="isEdit"
            no="getMBLInfoMark"
            type="primary"
            style="float:right;margin-left:5px"
            :disabled="readonly || !elementDict.mark.writable"
            @click="pm.getMBLInfo('mark')"
          >
            {{ $t('SeaExport.CopyMarksFromMbl') }}
          </el-button>
        </el-form-item>
        <el-form-item v-show="elementDict.mark.viewable" :label="$t('SeaExport.Marks')" :class="'auto-width '+variableCss.mark">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <special-character-tip :texts="specialCharCheck.mark">
            <cargo-rich-textarea
              ref="cargoTextarea2"
              v-model="form.mark"
              no="mark"
              :show-count="true"
              :text-chars="markMaxChars"
              :warning-count="markWarningCount"
              wrap-symbol="r"
              :disabled="!isEdit || !elementDict.mark.writable"
              :auto-uppercase="isUppercaseByConfig"
              auto-half-word
              style="height: 110px"
              :class="importDifferenceField.mark ? 'red-border' : ''"
              @change="pm.markBlurHandler()"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig,warningCount: markWarningCount,maxChar: markMaxChars})"
            />
          </special-character-tip>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.quantitySum.viewable" slot="quantitySum" class="auto-width">
        <line-label slot="label" :class="elementDict.quantitySum.isRequire ? 'blue' : ''" :label="elementDict.quantitySum.label" />
        <el-input v-model="form.quantitySum" :class="importDifferenceField.quantitySum ? 'red-border' : ''" :disabled="true" />
      </el-form-item>

      <el-form-item v-if="elementDict.hblNbr2.viewable" slot="hblNbr2">
        <line-label slot="label" :class="elementDict.hblNbr2.isRequire ? 'blue' : ''" :label="elementDict.hblNbr2.label" />
        <el-input v-model="form.hblNbr2" no="hblNbr2" :disabled="hblNoDisabled || readonly || !elementDict.hblNbr2.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.soNo.viewable" slot="soNo" :class="variableCss.soNoTitle">
        <line-label slot="label" :class="elementDict.soNo.isRequire ? 'blue' : ''" :label="elementDict.soNo.label" />
        <el-input :value="job.soNo.replace(/\n/g, ',')" :disabled="true" :class="variableCss.soNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.serialNo.viewable" slot="serialNo">
        <line-label slot="label" :class="elementDict.serialNo.isRequire ? 'blue' : ''" :label="elementDict.serialNo.label" />
        <el-input v-model="form.serialNo" :class="importDifferenceField.serialNo ? 'red-border' : ''" no="serialNo" :disabled="readonly || !elementDict.serialNo.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.vessel.viewable" slot="vessel" :class="variableCss.vesselTitle">
        <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
        <cargo-advance-select
          no="vessel"
          :disabled="readonly||!pm._lclslaveEnabled || readonly || !elementDict.vessel.writable"
          :select-type="selectTypeNames.basic_data_Vessel"
          filterable
          :allow-create="pm._allowEditingVessel"
          :default-value="job.vessel"
          style="width:100%;"
          :cache="false"
          :static-options="pm.vesselList"
          @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.viewable" slot="voyageFlight" :class="variableCss.voyageFlightTitle">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <cargo-advance-select
          ref="voyageFlight"
          no="voyageFlight"
          :static-options="pm._voyages || []"
          :cache="false"
          :default-value="job.voyageFlight"
          :disabled="readonly||!pm._lclslaveEnabled || readonly || !elementDict.voyageFlight.writable"
          filterable
          clearable
          :allow-create="pm.editVoyageMode===1"
          tag-name="voyageNo"
          tag-value="voyageNo"
          :filter-tag-names="['voyageNo']"
          @focus="pm.txtVoyageFocusInHandler()"
          @parentCallBack="p=>{pm.onVoyagaFlightChange(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.sailingDate.viewable" slot="sailingDate">
        <line-label slot="label" :class="elementDict.sailingDate.isRequire ? 'blue' : ''" :label="elementDict.sailingDate.label" />
        <el-input :value="sailingDate" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlaceCode.viewable" slot="dispatchingPlaceCode" :class="variableCss.dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dispatchingPlaceCode||''"
          tag-name="englishName"
          :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
          no="serialNo"
          @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
        />
        <el-input v-model="form.dispatchingPlace" :filter-chars="false" :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''" no="dispatchingPlace" :disabled="readonly || !elementDict.dispatchingPlaceCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortCode.viewable" slot="loadingPortCode" :class="variableCss.loadingPort">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.loadingPortCode||''"
          tag-name="englishName"
          no="loadingPortCode"
          :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
          @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
        />
        <el-input v-model="form.loadingPort" :filter-chars="false" :class="importDifferenceField.loadingPort ? 'red-border' : ''" no="loadingPort" :disabled="readonly || !elementDict.loadingPortCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode" :class="variableCss.dischargingPort">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode||''"
          tag-name="englishName"
          no="dischargingPortCode"
          :class="importDifferenceField.dischargingPortCode ? 'red-border' : ''"
          @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
        />
        <el-input v-model="form.dischargingPort" :filter-chars="false" :class="importDifferenceField.dischargingPort ? 'red-border' : ''" no="dischargingPort" :disabled="readonly || !elementDict.dischargingPortCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode" :class="variableCss.destinationPort">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode||''"
          tag-name="englishName"
          no="destinationPortCode"
          :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
          @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
        />
        <el-input v-model="form.destinationPort" :filter-chars="false" :class="importDifferenceField.destinationPort ? 'red-border' : ''" no="destinationPort" :disabled="readonly || !elementDict.destinationPortCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input v-model="form.destinationPlace" :filter-chars="false" :class="importDifferenceField.destinationPlace ? 'red-border' : ''" no="destinationPlace" :disabled="readonly || !elementDict.destinationPlace.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermHBL.viewable" slot="paymentTermHBL">
        <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
        <cargo-advance-select
          no="paymentTermHBL"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          filterable
          :default-value="job.paymentTermHBL"
          :allow-create="true"
          style="width:100%;"
          :disabled="readonly || !elementDict.paymentTermHBL.writable"
          @parentCallBack="p=>{pm.paymentSelectHblChange(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentPlaceBL.viewable" slot="paymentPlaceBL">
        <line-label slot="label" :class="elementDict.paymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.paymentPlaceBL.label" />
        <el-input v-model="form.paymentPlaceBL" :class="importDifferenceField.paymentPlaceBL ? 'red-border' : ''" no="paymentPlaceBL" :disabled="readonly || !elementDict.paymentPlaceBL.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTermHBL.viewable" slot="freightTermHBL">
        <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
        <el-input v-model="job.freightTermHBL" no="freightTermHBL" :disabled="readonly || !elementDict.freightTermHBL.writable" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.blNumber.viewable"
        slot="blNumber"
        :class="variableCss.BLNumber"
      >
        <line-label slot="label" :class="elementDict.blNumber.isRequire ? 'blue' : ''" :label="elementDict.blNumber.label" />
        <el-input v-model="form.blNumber" :class="importDifferenceField.blNumber ? 'red-border' : ''" no="blNumber" :disabled="readonly || !elementDict.blNumber.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.signPlaceBL.viewable" slot="signPlaceBL">
        <line-label slot="label" :class="elementDict.signPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.signPlaceBL.label" />
        <el-input v-model="form.signPlaceBL" :class="importDifferenceField.signPlaceBL ? 'red-border' : ''" no="signPlaceBL" :disabled="readonly || !elementDict.signPlaceBL.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.signDateBL.viewable" slot="signDateBL">
        <line-label slot="label" :class="elementDict.signDateBL.isRequire ? 'blue' : ''" :label="elementDict.signDateBL.label" />
        <el-date-picker v-model="form.signDateBL" :class="importDifferenceField.signDateBL ? 'red-border' : ''" no="signDateBL" type="date" value-format="yyyy-MM-dd" style="width:100%;" :disabled="readonly || !elementDict.signDateBL.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.viewable" slot="remarks" :class="variableCss.remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <cargo-input
          v-model="form.remarks"
          no="remarks"
          type="textarea"
          :rows="5"
          :filter-chars="false"
          :class="importDifferenceField.remarks ? 'red-border' : ''"
          :disabled="readonly || !elementDict.remarks.writable"
          :use-read-only="true"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
        <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
        <el-input
          v-if="syncHblHsCodeEdit"
          v-model="form.hsCode"
          no="hsCode"
          type="textarea"
          :rows="5"
          style="width: 100%"
          :class="importDifferenceField.hsCode ? 'red-border' : ''"
          :disabled="readonly || !elementDict.hsCode.writable"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
        />
        <el-input
          v-else
          v-model="job.hsCode"
          no="hsCode"
          type="textarea"
          :rows="5"
          style="width: 100%"
          :class="importDifferenceField.hsCode ? 'red-border' : ''"
          :disabled="readonly || !elementDict.hsCode.writable"
          @input="val=>{hsCodeChangeHandle(val)}"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{hsCodeChangeHandle(val)})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerCfmException.viewable" slot="customerCfmException">
        <line-label slot="label" :class="elementDict.customerCfmException.isRequire ? 'blue' : ''" :label="elementDict.customerCfmException.label" />
        <el-input
          v-model="form.customerCfmException"
          no="customerCfmException"
          type="textarea"
          :rows="5"
          :disabled="readonly || !elementDict.customerCfmException.writable"
          :class="importDifferenceField.customerCfmException ? 'red-border' : ''"
          @dblclick.native="showAdvanceTextDialog(elementDict.customerCfmException.label,form.customerCfmException,val=>{form.customerCfmException=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.releaseType.viewable" slot="releaseType">
        <line-label slot="label" :class="elementDict.releaseType.isRequire ? 'blue' : ''" :label="elementDict.releaseType.label" />
        <el-select
          v-model="form.releaseType"
          :disabled="readonly || !elementDict.releaseType.writable"
          no="releaseType"
          :class="importDifferenceField.releaseType ? 'red-border' : ''"
          @change="val=>{pm.cmbreleaseTypeMBL_changeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in blModeList"
            :key="index"
            :label="item.name"
            :value="item.serialNumber"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.issuerBL.viewable" slot="issuerBL">
        <line-label slot="label" :class="elementDict.issuerBL.isRequire ? 'blue' : ''" :label="elementDict.issuerBL.label" />
        <cargo-advance-select
          :disabled="readonly || !elementDict.issuerBL.writable"
          no="issuerBL"
          :select-type="selectTypeNames.basic_data_OrderFormType"
          filterable
          :default-value="form.issuerBL"
          style="width:100%;"
          :tag-name="isZh ? 'name' : 'englishName'"
          :clearable="false"
          :class="importDifferenceField.issuerBL ? 'red-border' : ''"
          @parentCallBack="p=>{pm.cmbissuerHBL_changeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.typeHBL.viewable" slot="typeHBL">
        <line-label slot="label" :class="elementDict.typeHBL.isRequire ? 'blue' : ''" :label="elementDict.typeHBL.label" />
        <el-select
          :value="job.typeHBL||1"
          no="typeHBL"
          :disabled="cmbtypeHBLDisabled || readonly || !elementDict.typeHBL.writable"
          :clearable="false"
          @input="val=>{pm.cmbtypeHBLChangeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in BILL_TYPES"
            :key="index"
            :label="isZh ? item.chineseName : item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-show="elementDict.jointMasterHBLJobNo.viewable && job.jointMasterHBLUuid" slot="jointMasterHBLJobNo">
        <line-label slot="label" :class="elementDict.jointMasterHBLJobNo.isRequire ? 'blue' : ''" :label="elementDict.jointMasterHBLJobNo.label" />
        <el-input :value="job.jointMasterHBL?job.jointMasterHBL.jobNo:''" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.lblCfrState.viewable" slot="lblCfrState" class="red">
        <line-label slot="label" :class="elementDict.lblCfrState.isRequire ? 'blue' : ''" :label="elementDict.lblCfrState.label" :disabled="readonly" />
        <div style="display: flex">
          <el-input :value="lblCfrState" :disabled="true" style="flex: 1" />
          <el-link
            v-if="showXhqOverseasAgentFeedbackLink"
            no="xhqOverseasAgentFeedbackLink"
            style="color: blue;margin-left: 5px"
            @click="xhqShowOverseasAgentFeedbackDialog"
          >{{ $t('SeaExport.View') }}
          </el-link>
        </div>
      </el-form-item>
      <!-- 提单签发状态 -->
      <el-form-item v-if="elementDict.billLadingIssued.viewable" slot="billLadingIssued" class="red">
        <line-label slot="label" :class="elementDict.billLadingIssued.isRequire ? 'blue' : ''" :label="elementDict.billLadingIssued.label" />
        <el-input :value="billLadingIssued" :disabled="true" />
      </el-form-item>
      <template v-if="elementDict.lblReleaseState.viewable" slot="lblReleaseState">
        <el-form-item label-width="0">
          <el-button
            v-if="OpenXHQDocumentCenter && (job.typeHBL === 0 || job.typeHBL === 1)"
            v-permission="['button_HBL_surrendered']"
            :disabled="isEdit"
            no="surrendered"
            type="primary"
            @click="pm.toSurrendered()"
          >{{ $t('SeaExport.Surrendered') }}</el-button>
        </el-form-item>
        <el-form-item class="red">
          <line-label slot="label" :class="elementDict.lblReleaseState.isRequire ? 'blue' : ''" :label="elementDict.lblReleaseState.label" />
          <el-input :value="lblReleaseState" :disabled="true" />
        </el-form-item>
      </template>
      <template v-if="elementDict.requestReleaseState.viewable" slot="requestReleaseState">
        <el-form-item class="red">
          <line-label slot="label" :class="elementDict.requestReleaseState.isRequire ? 'blue' : ''" :label="elementDict.requestReleaseState.label" />
          <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
          <span style="float:left;margin-left:-85px">{{ job.jointMasterHBLUuid ? $t('SeaExport.TicketHasMerged') : (job.typeHBL === BillType.SPLIT_BILL_TYPE.code) ? $t('SeaExport.TicketHasSplit') : '' }}</span>
          <cargo-button-container
            no="requestReleaseState"
            :disabled="btnBLConfirmDisabled || !cooperateEdit || !elementDict.requestReleaseState.writable"
            style="float:right;margin-left:5px"
            @click="pm.btnRequestReleasingClickHandler()"
          >
            <el-button v-permission="['button_M/HBL_SingleReleaseHBL']" :disabled="job.jointMasterHBLUuid || job.typeHBL === BillType.SPLIT_BILL_TYPE.code" type="primary">
              {{ form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease') }}
            </el-button>
          </cargo-button-container>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            :value="form.releaseReview===1"
            :disabled="true"
            style="margin-right: 6px;"
          >{{ $t('SeaExport.DataSent') }}</el-checkbox>
          <el-checkbox :value="form.payable" :disabled="true" style="margin-right: 6px;">{{ $t('SeaExport.Completed') }}</el-checkbox>
          <el-checkbox :value="form.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
        </el-form-item>
      </template>
      <template v-if="elementDict.releaseEligibleStatus && elementDict.releaseEligibleStatus.viewable" slot="releaseEligibleStatus">
        <el-form-item class="red">
          <line-label slot="label" :class="elementDict.releaseEligibleStatus.isRequire ? 'blue' : ''" :label="elementDict.releaseEligibleStatus.label" />
          <el-input :value="releaseEligibleLabel" :disabled="true" />
        </el-form-item>
      </template>
      <el-form-item
        v-if="elementDict.longTermGuaranteeState.viewable && form.guaranteeConfigEnable"
        slot="longTermGuaranteeState"
        :label="$t('SeaExport.LongTermGuaranteeState')"
        class="red"
      >
        <line-label slot="label" :class="elementDict.longTermGuaranteeState.isRequire ? 'blue' : ''" :label="elementDict.longTermGuaranteeState.label" />
        <el-input :value="SystemConstants.LONG_TERM_GUARANTEE_STATE_MAP.get(form.longTermGuaranteeState)" :disabled="true" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.singleTicketGuaranteeState.viewable && form.guaranteeConfigEnable"
        slot="singleTicketGuaranteeState"
        :label="$t('SeaExport.SingleTicketGuaranteeState')"
        class="red"
      >
        <line-label slot="label" :class="elementDict.singleTicketGuaranteeState.isRequire ? 'blue' : ''" :label="elementDict.singleTicketGuaranteeState.label" />
        <el-input :value="SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_MAP.get(form.singleTicketGuaranteeState)" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.agreePayDate.viewable" slot="agreePayDate">
        <line-label slot="label" :class="elementDict.agreePayDate.isRequire ? 'blue' : ''" :label="elementDict.agreePayDate.label" />
        <el-date-picker
          v-model="form.agreePayDate"
          no="agreePayDate"
          :disabled="isDatePickerDisabled || !elementDict.agreePayDate.writable"
          type="date"
          style="width: 100%;"
          value-format="yyyy-MM-dd"
          @input="handleDateChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.withholdDate.viewable" slot="withholdDate">
        <line-label slot="label" :class="elementDict.withholdDate.isRequire ? 'blue' : ''" :label="elementDict.withholdDate.label" />
        <el-date-picker
          v-model="form.withholdDate"
          no="withholdDate"
          :disabled="true"
          type="date"
          style="width: 100%;"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.printParam4.viewable" slot="printParam4">
        <line-label slot="label" :class="elementDict.printParam4.isRequire ? 'blue' : ''" :label="elementDict.printParam4.label" />
        <el-select v-model="form.printParam4" :disabled="readonly || !elementDict.printParam4.writable" :class="importDifferenceField.printParam4 ? 'red-border' : ''" no="printParam4" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" filterable allow-create>
          <el-option
            v-for="(item,index) in pm.printParam4Type"
            :key="index"
            :label="item.label"
            :value="item.data"
            :class="importDifferenceField.printParam4 ? 'red-border' : ''"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.printParam5.viewable" slot="printParam5">
        <line-label slot="label" :class="elementDict.printParam5.isRequire ? 'blue' : ''" :label="elementDict.printParam5.label" />
        <el-select v-model="form.printParam5" :disabled="readonly || !elementDict.printParam5.writable" :class="importDifferenceField.printParam5 ? 'red-border' : ''" no="printParam5" :placeholder="readonly ? '': $t('CargoMsg.Cargo_PleaseSelect')">
          <el-option
            v-for="(item,index) in pm.printParam5Type"
            :key="index"
            :label="item.label"
            :value="item.data"
            :class="importDifferenceField.printParam5 ? 'red-border' : ''"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.txtCarrierScAc.viewable" slot="txtCarrierScAc">
        <line-label slot="label" :class="elementDict.txtCarrierScAc.isRequire ? 'blue' : ''" :label="elementDict.txtCarrierScAc.label" />
        <el-input :value="job.carrierScac || txtCarrierScAc" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.txtBookingAgentScAc.viewable" slot="txtBookingAgentScAc">
        <line-label slot="label" :class="elementDict.txtBookingAgentScAc.isRequire ? 'blue' : ''" :label="elementDict.txtBookingAgentScAc.label" />
        <el-input :value="txtBookingAgentScAc" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.shipperTel.viewable" slot="shipperTel">
        <line-label slot="label" :class="elementDict.shipperTel.isRequire ? 'blue' : ''" :label="elementDict.shipperTel.label" />
        <el-input v-model="form.shipperTel" :class="importDifferenceField.shipperTel ? 'red-border' : ''" :disabled="readonly || !elementDict.shipperTel.writable" no="shipperTel" />
      </el-form-item>
      <el-form-item v-if="elementDict.consigneeTel.viewable" slot="consigneeTel">
        <line-label slot="label" :class="elementDict.consigneeTel.isRequire ? 'blue' : ''" :label="elementDict.consigneeTel.label" />
        <el-input v-model="form.consigneeTel" :class="importDifferenceField.consigneeTel ? 'red-border' : ''" :disabled="readonly || !elementDict.consigneeTel.writable" no="consigneeTel" />
      </el-form-item>
      <el-form-item v-if="elementDict.notifyTel.viewable" slot="notifyTel">
        <line-label slot="label" :class="elementDict.notifyTel.isRequire ? 'blue' : ''" :label="elementDict.notifyTel.label" />
        <el-input v-model="form.notifyTel" :class="importDifferenceField.notifyTel ? 'red-border' : ''" :disabled="readonly || !elementDict.notifyTel.writable" no="notifyTel" />
      </el-form-item>
      <template v-if="elementDict.container.viewable" slot="container">
        <el-form-item>
          <line-label slot="label" :class="elementDict.container.isRequire ? 'blue' : ''" :label="elementDict.container.label" />
          <el-button
            :disabled="readonly || !elementDict.container.writable"
            type="primary"
            @click="getPackingInformation"
          >
            {{ $t('SeaExport.GetPackingInformation') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <cargo-input
            v-model="form.container"
            :disabled="readonly || !elementDict.container.writable"
            no="container"
            :auto-uppercase="true"
            type="textarea"
            :rows="5"
            style="width:100%"
            :filter-chars="false"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.withholdReason.viewable" slot="withholdReason">
        <line-label slot="label" :class="elementDict.withholdReason.isRequire ? 'blue' : ''" :label="elementDict.withholdReason.label" />
        <el-input :value="form.withholdReason" type="textarea" :rows="5" :disabled="true" style="width: 100%;" />
      </el-form-item>
      <el-form-item v-if="elementDict.modificationCount.viewable" slot="modificationCount">
        <line-label slot="label" :class="elementDict.modificationCount.isRequire ? 'blue' : ''" :label="elementDict.modificationCount.label" />
        <auto-number-input v-model="form.modificationCount" :disabled="readonly || !elementDict.modificationCount.writable" :precision="0" :min="0" no="modificationCount" />
      </el-form-item>
      <el-form-item v-if="elementDict.portRequirement.viewable" slot="portRequirement">
        <line-label slot="label" :class="elementDict.portRequirement.isRequire ? 'blue' : ''" :label="elementDict.portRequirement.label" />
        <el-input v-model="form.portRequirement" :disabled="readonly || !elementDict.portRequirement.writable" no="portRequirement" type="textarea" :rows="5" />
        <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
          <i class="el-icon-paperclip" style="font-size: 16px;" />
          <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
        </div>
      </el-form-item>
      <div v-if="elementDict.freightChargesInfo.viewable" slot="freightChargesInfo" class="section">
        <span class="title">{{ $t('SeaExport.freightChargesInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit&&form.uuid" style="padding:5px 0">
            <el-button no="Add" type="primary" @click="showEditDialog(true)">{{ $t('SeaExport.Add') }}</el-button>
            <el-button no="Edit" type="primary" @click="showEditDialog(false)">{{ $t('SeaExport.Edit') }}</el-button>
            <el-button no="Delete" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="finalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
          <div style="padding:5px 0;font-size:12px">
            <span style="color:#0A0AFF">{{ $t('SeaExport.freightChargesUSDTotal') }}</span>
            <i style="margin-left:15px;margin-right:5px">{{ form.freightChargeEnUpper }}</i>
            <i>({{ NumberUtils.formatNumber(form.freightChargeTotal, 2) }})</i>
          </div>
        </div>
      </div>
    </tab-HBL-UICustom-layout>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :params="form"
      @callback="codeSearchCallback"
    />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!-- 邀请对单弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :context="context"
      :job="job"
      source="tabHBL"
      :push-link="SystemConstants.HBL_INVITATION_STATEMENT"
      :is-copy-link="true"
      :job-eamil-data="jobEamilData"
      :send-email-data="emailInput"
      :send-call-back="onEmailExecute"
    />
    <!-- 对单历史弹窗 -->
    <match-history-dialog :visible.sync="matchHistoryDialog.visible" :cargo-doc-uuid="form.uuid" />
    <!-- 抄录弹窗 -->
    <transcribe-dialog :visible.sync="transcribeDialog.visible" :job="job" @callback="transcribeCallback" />
    <!-- 反恐地址格式化弹窗 -->
    <address-format-dialog
      :visible.sync="addressFormatDialog.visible"
      :job="addressFormatDialog.job"
      :params="addressFormatDialog.params"
    />
    <!-- 批量验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单个验证弹窗 -->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
      :return-main-callback="returnMainCallback"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="465px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('SeaExport.ChargeItem')">
            <cargo-advance-select
              no="chargeItemId"
              :select-type="selectTypeNames.basic_data_ChargeItem"
              filterable
              :default-value="editDialog.form.chargeItemId||''"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargeClause')">
            <cargo-advance-select
              no="paymentTermHBL"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              filterable
              :default-value="editDialog.form.paymentTermHBL"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Currency')">
            <cargo-advance-select
              no="currency"
              :select-type="selectTypeNames.basic_data_Currency"
              filterable
              :default-value="editDialog.form.currency"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.currency=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <cargo-advance-select
              no="eqSize"
              :select-type="selectTypeNames.local_cache_EQSize"
              :headers="[$t('SeaExport.Code2')]"
              :fields="['code']"
              filterable
              :default-value="editDialog.form.eqSize"
              tag-name="code"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerType')">
            <cargo-advance-select
              no="eqType"
              :select-type="selectTypeNames.basic_data_EQType"
              :headers="[$t('SeaExport.Code2')]"
              :fields="['code']"
              filterable
              :default-value="editDialog.form.eqType"
              tag-name="code"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Quantity2')">
            <el-input-number
              v-model="editDialog.form.quantity"
              no="quantity"
              :precision="0"
              :controls="false"
              style="width:100%"
              @change="p => {caculateAmount(); pm.changeBillOfLadingSynJob()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UnitRate')">
            <el-input-number
              v-model="editDialog.form.unitRate"
              no="unitRate"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Amount')">
            <el-input-number
              v-model="editDialog.form.amount"
              no="amount"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="editDialog.form.unitRate=editDialog.form.amount"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save2" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel2" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :file-size="cloudFile.fileSize"
      :file-category="cloudFile.fileCategory"
      :file-category-label="cloudFile.fileCategoryLabel"
      :upload-source="cloudFile.uploadSource"
      :other-param="cloudFile.otherParam"
      @uploadDone="onUploadDone"
    />
    <el-dialog
      :visible.sync="checkTheBLLog.visible"
      :title="$t('SeaExport.CheckTheBLCenterApiLog')"
      width="1000px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      top="5vh"
      custom-class="details-view settlement-notice"
    >
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="checkTheBLLog.gridParams"
            :grid-options="checkTheBLLog.gridOptions"
            :column-defs="checkTheBLLog.columnDefs"
            :row-data="checkTheBLLog.rowData"
          />
        </div>
      </div>
    </el-dialog>
    <xhq-overseas-agent-feedback-dialog
      :visible.sync="xhqOverseasAgentFeedbackDialog.visible"
      :data="xhqOverseasAgentFeedbackDialog.data"
      :callback="xhqOverseasAgentFeedbackDialog.callback"
    />
    <!--保函上传文件-->
    <guarantee-file-dialog
      :visible.sync="guaranteeFileDialog.visible"
      :model="guaranteeFileDialog.model"
      :title="$t('Message.fileManagement')"
    />
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="p => {}"
    />
    <!-- 打印文件(用于指令处理) -->
    <print-file-window ref="printFileWindow" @instructionCallback="onInstructionCallback" @lockHbl="onLockHbl" />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabHBLUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBLUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabHBL from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL'
import StrUtils from '@/utils/StrUtils'
import { getJobInstructions } from '@/api/sysManage/uiCustom'
import printFileWindow from '@/components/Cargo/Job/instructionManager/printFileWindow'

export default {
  name: 'TabHBLUICustom',
  components: { tabHBLUICustomLayout, printFileWindow },
  extends: tabHBL,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      instructioinBtns: [],
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh, pendTabSize) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh, pendTabSize)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_HBL, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_HBL, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
      this.ensureReleaseEligibleStatus()
    },
    ensureReleaseEligibleStatus() {
      if (this.elementDict && this.elementDict.releaseEligibleStatus) return
      if (!this.elementDict) this.elementDict = {}
      const label = this.$t('SeaExport.ReleaseEligibleStatus')
      this.elementDict.releaseEligibleStatus = {
        visible: true,
        masterVisible: true,
        slaveVisible: true,
        isRequire: false,
        customLabel: null,
        label,
        fieldNames: [],
        multipleRole: null,
        jobPositionFields: null,
        ownPrivilegePositionFields: null,
        positionPrivilegeViewable: null,
        positionPrivilegeWritable: null,
        viewable: true,
        writable: false,
        userCustomContent: '',
        customContent: ''
      }
      if (!Array.isArray(this.elementBlocks)) return
      const targetBlock = this.elementBlocks.find(block => Array.isArray(block.elementNames) && block.elementNames.includes('requestReleaseState')) || this.elementBlocks[0]
      if (!targetBlock || !Array.isArray(targetBlock.elementNames)) return
      if (!targetBlock.elementNames.includes('releaseEligibleStatus')) {
        const index = targetBlock.elementNames.indexOf('requestReleaseState')
        if (index >= 0) {
          targetBlock.elementNames.splice(index + 1, 0, 'releaseEligibleStatus')
        } else {
          targetBlock.elementNames.push('releaseEligibleStatus')
        }
      }
    },
    onJobChange() {
      this.loadInstructionBtns()
    },
    validateForm() {
      const form = this.form
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!(element.visible && element.writable && element.isRequire)) {
          continue
        }
        if (name === 'shipper') {
          let shipperLine = ''
          for (let i = 1; i <= 7; ++i) {
            shipperLine += form['shipperLine' + i]
          }
          if (StrUtils.isEmpty(shipperLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'consignee') {
          let consigneeLine = ''
          for (let i = 1; i <= 7; ++i) {
            consigneeLine += form['consigneeLine' + i]
          }
          if (StrUtils.isEmpty(consigneeLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'notify') {
          let notifyLine = ''
          for (let i = 1; i <= 7; ++i) {
            notifyLine += form['notifyLine' + i]
          }
          if (StrUtils.isEmpty(notifyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'agentParty') {
          let agentPartyLine = ''
          for (let i = 1; i <= 7; ++i) {
            agentPartyLine += form['agentPartyLine' + i]
          }
          if (StrUtils.isEmpty(agentPartyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'dispatchingPlaceCode') {
          if (StrUtils.isEmpty(form.dispatchingPlaceCode) || StrUtils.isEmpty(form.dispatchingPlace)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'loadingPortCode') {
          if (StrUtils.isEmpty(form.loadingPortCode) || StrUtils.isEmpty(form.loadingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'dischargingPortCode') {
          if (StrUtils.isEmpty(form.dischargingPortCode) || StrUtils.isEmpty(form.dischargingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'destinationPortCode') {
          if (StrUtils.isEmpty(form.destinationPortCode) || StrUtils.isEmpty(form.destinationPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'insideQuantity') {
          if (StrUtils.isEmpty(this.job.insideQuantity)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabHBL')
          }
          continue
        }
        if (name === 'weight' || name === 'cubage') {
          if (!this.pm.isCanEditQwc || !this.isJydEditJobFields) {
            continue
          }
        }
        if (name === 'requestReleaseState') {
          continue
        }
        if (element.fieldNames && element.fieldNames.length > 0) {
          for (const key of element.fieldNames) {
            const field = this.fieldDict[key]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabHBL')
            }
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return this.superFunction()
    },
    // 加载指令按钮
    async loadInstructionBtns() {
      const useHqSet = UICustomUtil.getUseHqSet(UICustomConstants.SEA_BOOKING_HBL, this.$store.getters.currentOfficeId)
      const res = await getJobInstructions({
        pageType: UICustomConstants.SEA_BOOKING_HBL,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet,
        jobKey: this.job.uuid,
        lob: this.job.lob
      })
      this.instructioinBtns = res.data
    },
    onInstructionClick(item) {
      if (item.platformInstructionRuleCode === this.SystemConstants.PLATFORM_INSTRUCTION_CODE_PRINT_FILE.code) {
        this.$refs.printFileWindow.onShowOfUI(item, this.job)
      }
    },
    onInstructionCallback() {
      this.loadInstructionBtns()
    },
    onLockHbl() {
      this.form.state = 2
    }
  }
}
</script>

<style lang="scss" scoped>
.mbl-red::v-deep{
  .el-input__inner {
    color: red !important;
  }
}
.triggers{
  .operat-wrap{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .el-checkbox{
      margin-right: 15px;
      &:first-of-type{
        margin-left: 20px;
      }
    }
  }
}
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}

</style>
<style>
.messageIndex{
  z-index:99999 !important;
}
</style>
